import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import { Row, Col } from 'react-bootstrap';

const Pengajuan = ({ nama, url }) => (
  <Row className="mt-3 border-dark border-bottom ml-1 mr-1">
    <Col><p className="text-capitalize">{nama}</p></Col>
    <Col><Button variant="primary  btn-detail text-capitalize" href={url}>Lihat Detail</Button></Col>
  </Row>
);

Pengajuan.propTypes = {
  nama: PropTypes.string,
  url: PropTypes.string,
};

Pengajuan.defaultProps = {
  nama: '',
  url: '',
};

export default Pengajuan;
